/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Start a stopped preview deployment so it serves traffic again.
 */
export type V1DeploymentsStartDeploymentRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  deploymentId: string;
};

/** @internal */
export type V1DeploymentsStartDeploymentRequestBody$Outbound = {
  deploymentId: string;
};

/** @internal */
export const V1DeploymentsStartDeploymentRequestBody$outboundSchema: z.ZodType<
  V1DeploymentsStartDeploymentRequestBody$Outbound,
  z.ZodTypeDef,
  V1DeploymentsStartDeploymentRequestBody
> = z.object({
  deploymentId: z.string(),
});

export function v1DeploymentsStartDeploymentRequestBodyToJSON(
  v1DeploymentsStartDeploymentRequestBody:
    V1DeploymentsStartDeploymentRequestBody,
): string {
  return JSON.stringify(
    V1DeploymentsStartDeploymentRequestBody$outboundSchema.parse(
      v1DeploymentsStartDeploymentRequestBody,
    ),
  );
}
